import { isSim, isPre } from '@/utils/env';

export default {
  isDev:
    process.env.NODE_ENV === 'development' || process.env.STORYBOOK === 'true',
  isSim: isSim(),
  isPre: isPre(),
  isPro:
    process.env.NODE_ENV === 'production' &&
    process.env.BUILD_ENV !== 'development',
  isDiDi: location.host.indexOf('didi-food') !== -1,
  is99: location.host.indexOf('99app') !== -1,
};
